import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleHero from './components/ArticleHero';
import ArticleBody from './components/ArticleBody';
import RelatedPosts from './components/RelatedPosts';
import BottomCTA from '@/pages/blog/components/BottomCTA';
import { blogPostingJsonLd } from '@/components/feature/BlogPostingJsonLd';

const jsonLd = blogPostingJsonLd({
  headline: "Enhance Your Festival's Appeal: Strategic Uses of Stretch Tents for Better Guest Experience",
  description: 'Learn how strategically placed stretch tents can improve crowd flow, shelter, and the overall festival atmosphere, turning any outdoor event into an immersive, memorable experience.',
  url: `${import.meta.env.VITE_SITE_URL || 'https://popprotents.com'}/blog/enhance-festival-appeal-stretch-tents`,
  datePublished: '2026-02-18',
  dateModified: '2026-06-29',
  authorName: 'Pop Pro Tents Team',
  keywords: ['festival stretch tents', 'festival guest experience', 'outdoor event design', 'festival layout', 'crowd flow'],
});

export default function EnhanceFestivalAppealPage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <ArticleHero />
        <ArticleBody />
        <RelatedPosts />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}